export default __webpack_public_path__ + "static/media/phone.065c45ec.jpg";